<template>
  <div class="action-confirmation-container">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h3 class="title has-text-white has-text-centered">{{ title }}</h3>
          <div class="box custom-box">
            <div class="message-container has-text-left">
              <b-icon
                class="custom-icon"
                icon="alert-box"
                size="is-large"
                :type="habilitar ? 'is-info' : 'is-warning'"
              ></b-icon>
              <div class="message-warning-container">
                <div class="warning-text">
                  Com esta ação o fornecedor
                  <strong>{{ supplierLabel }}</strong> será
                  <strong>{{ habilitar ? 'habilitado' : 'inabilitado' }}</strong>
                  {{ scopeLabel }}
                </div>
              </div>
            </div>

            <div v-if="items.length" class="batch-items-list">
              <p class="has-text-weight-semibold">Itens afetados:</p>
              <div class="batch-items-scroll">
                <div
                  v-for="item in items"
                  :key="`batch-item-${item.identifier}`"
                  class="batch-item"
                >
                  <p class="has-text-weight-semibold">
                    Item {{ item.identifier
                    }}<span v-if="item.description"> - {{ item.description }}</span>
                  </p>
                </div>
              </div>
            </div>

            <b-field
              class="custom-justification-field"
              label="Justificativa"
              :type="campoInvalido('justificativa', 'data') ? 'is-danger' : ''"
              :message="
                campoInvalido('justificativa', 'data') && requiresJustification
                  ? 'Justificativa é um campo obrigatório'
                  : ''
              "
            >
              <b-input
                type="textarea"
                class="custom-textarea"
                ref="justificativa"
                rows="4"
                maxlength="2000"
                :placeholder="placeholder"
                v-model="data.justificativa"
              />
            </b-field>

            <div class="footer-container">
              <div class="buttons-container has-text-right">
                <b-button
                  class="rm-1"
                  :size="mobile ? 'is-small' : 'is-normal'"
                  :disabled="loading"
                  @click.stop.prevent="closeModal()"
                >
                  Cancelar
                </b-button>

                <b-button
                  ref="confirm"
                  :class="{ 'is-outlined': !habilitar }"
                  :type="habilitar ? 'is-success' : 'is-danger'"
                  :size="mobile ? 'is-small' : 'is-normal'"
                  :loading="loading"
                  @click.stop.prevent="sendConfirmation"
                >
                  {{ confirmText }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

import fieldMixin from '@/mixins/formulario';

export default {
  name: 'AppBatchQualificationConfirmation',
  mixins: [fieldMixin],
  props: {
    confirmText: { type: String, default: 'Confirmar' },
    habilitar: { type: Boolean, default: true },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false },
    scopeLabel: {
      type: String,
      default: 'em todos os itens abaixo em que ele possui o melhor lance.',
    },
    supplierLabel: { type: String, default: '' },
    title: { type: String, default: 'Avaliar Todos' },
  },
  data() {
    return {
      data: {
        justificativa: '',
      },
    };
  },
  computed: {
    requiresJustification() {
      return !this.habilitar;
    },
    placeholder() {
      return this.habilitar
        ? 'Justificativa opcional para habilitar todos.'
        : 'Justifique a inabilitação de todos.';
    },
  },
  validations: {
    data: {
      justificativa: {
        required: requiredIf(function requiredForDisqualification() {
          return this.requiresJustification;
        }),
      },
    },
  },
  methods: {
    closeModal() {
      if (typeof this.$parent.onCancel === 'function') {
        this.$parent.onCancel();
      }
      if (typeof this.$parent.close === 'function') {
        this.$parent.close();
      }
    },
    sendConfirmation() {
      const justification = (this.data.justificativa || '').trim();
      if (this.requiresJustification && !justification) {
        this.$v.data.$touch();
        return;
      }

      this.$parent.$emit('confirm', { justificativa: justification });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.justificativa) {
        this.$refs.justificativa.focus();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.action-confirmation-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.batch-item {
  border-top: 1px solid #e9e9e9;
  margin-top: 0.5rem;
  padding-top: 0.5rem;

  &:first-child {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
  }
}

.batch-items-list {
  margin-top: 0.75rem;
}

.batch-items-scroll {
  max-height: 40vh;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.buttons-container {
  margin-top: 1rem;
}

.custom-box {
  display: flex;
  flex-direction: column;
}

.custom-icon {
  margin-right: 0.5rem;
}

.custom-justification-field {
  margin-bottom: 0.5rem;
  margin-top: 1rem;
}

.custom-textarea {
  width: 100%;
}

.footer-container {
  margin-top: 0.5rem;
}

.message-container {
  align-items: center;
  display: flex;
  margin-bottom: 0.5rem;
}

.rm-1 {
  margin-right: 3px;
}

.warning-text {
  margin-bottom: 0.5rem;
}
</style>
